import { TextColor } from '@kite-js/theme-types';

const textScale: TextColor = {
    100: '#D5D7DB',
    300: '#757575',
    500: '#525252',
    800: '#000000',
};

export default textScale;
